<template>
  <!--<transition :name='interaction.overlay ? "fade" : ""'>-->
    <div v-show='visible' class='interaction' :class="{active, required, noRewind, secondaryStream, white : !interactionMeta.darkMode && interaction.position.opacity === 1 || interaction.position.position_type === 'sidebar'}" :style='interaction_style' @scroll="handleScroll($event.target)" ref="interaction">
       <!--<v-progress-linear  v-if='showProgress' v-model="remainingTime" class='time-progress'></v-progress-linear> -->
      <interaction :interaction-id="interactionId" :visible="visible" :frame_id='frame_id' ></interaction>
      <div class="scroll-bottom-block" v-show="showScrollToBottom" :class="{'enabled': showScrollToBottom}">
       More Below
      </div>
    </div>
  <!--</transition>-->
</template>

<script>
/* eslint-disable */
import { waitForElementToDisplay } from '@/js/helpers.js';
import EventBus from '@/buses/EventBus';
import Interaction from '@/components/interaction/Interaction';
import _ from 'lodash';
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'interaction-wrapper',
  props: [
    'interactionId',
    'hidden',
    'sidebarStyle'
  ],
  components: {
    Interaction
  },
  data() {
    return {
      frame_id: null,
      showScrollToBottom: false,
      secondaryStream: false,
    };
  },
  computed: {
     ...mapGetters('player', [
      'displayTime',
      'sidebarOpen',
      'sidebarTab',
      'sidebarTransitioned',
      'hasPlayerKeyboardShortcutsFeature',
    ]),
    ...mapGetters('interactions', [
      'activeInteraction',
    ]),
    active() {
      if (this.activeInteraction) return this.interaction.id === this.activeInteraction.id;
      return false;
    },
    interaction() {
      return this.$store.getters['interactions/interaction'](this.interactionId) || {};
    },
    interactionAttempt() {
      return this.$store.getters['interactions/interactionAttempt'](this.interactionId) || {};
    },
    interactionMeta() {
      return this.$store.getters['interactions/interactionMeta'](this.interactionId) || {};
    },
    interactionKey() {
      return this.interaction.id;
    },
    noRewind() {
      return !(this.interaction.rewind || this.interactionMeta.isInteractionAnswered);
    },
    required() {
      return this.interaction.required && !this.interactionMeta.isInteractionAnswered;
    },
    visible() {
      /**
       * Only show the sidebar interactions if they are the active interaction and only show overlay
       * interactions when they are pulsing.
       */
      // [ ] update to return sidebar closed: visible false
      // [ ] update to return hotspot hidden: visible false
      const isActive = this.activeInteraction ? this.activeInteraction.id === this.interaction.id : false;
      // [ ] refactor
      if (this.interactionMeta.overlay) {
        // Other overlay interaction display based on pulse
        return this.interactionMeta.inDisplayRange && !this.hidden;
      }
      if (this.interactionMeta.rubric && this.sidebarOpen && this.sidebarTab === 'rubric-tab') {
        return true;
      }
      return isActive && this.sidebarOpen;
    },
    interaction_style() {
      // set hight for the interaction container div, if we are showing the progress bar we have to tweak the top height
      const height = this.show_progress ? 'calc(100% - 16px)' : '100%';
      let transition = 'none !important';
      if (_.has(this.interaction, 'overlay') && this.interaction.overlay) {
        // transition = 'all .5s cubic-bezier(0.25, 0.8, 0.5, 1)'
      }
      return "";
      // return { height, transition }
    },
    remainingTime() {
      return (this.displayTime - this.interaction.displayInTime) / (this.interaction.displayOutTime - this.interaction.displayInTime) * 100;
    },
    showProgress() {
      return this.interaction.displayOutTime - this.interaction.displayInTime > .1;
    },
  },
  methods: {
    ...mapMutations('interactions', [
      'updateInteraction',
      'updateInteractionAttempt',
      'updateInteractionMeta',
    ]),
    handleScroll(el) {
      // console.trace();
      // if (!el) return;
      // this.$nextTick(() => {
      //   const offset = this.interactionMeta.overlay ? 55 : 0;
      //   // console.log( el, el.scrollHeight,  el.clientHeight + offset);
      //   this.showScrollToBottom = (el.scrollHeight > el.clientHeight + offset && el.scrollTop === 0);
      // });
    },
    // scrollToBottom(e) {
    //   const scroll_area = e.target.closest('.interaction');
    //   scroll_area.scrollTo({
    //     top: scroll_area.clientHeight,
    //     behavior: 'smooth'
    //   });
    // },
  },

  mounted() {
    this.frame_id = `${new Date().getTime()}-${this.interactionMeta.overlay ? 'h' : 's'}-${this.interaction.id}`;
    if (!this.interactionMeta.rubric) this.handleScroll(this.$refs.interaction);
    this.secondaryStream = this.interaction.interactionType == 'secondary_stream';
    // this.$el.addEventListener("transitionend", () => { });
  },

  watch: {
    'visible'(newValue, oldValue) {
      if (this.hasPlayerKeyboardShortcutsFeature) {
        document.dispatchEvent(new CustomEvent('hotkeys:visible-interaction', { detail: {
          newValue,
          oldValue,
          overlay: this.interactionMeta.overlay,
          activeInteraction: this.activeInteraction,
          }
        }));
      }
    }
  },
};
</script>

<style scoped>
  .interaction {
    -webkit-overflow-scrolling: touch;
  	overflow-y: auto;
  	flex-grow:1;
  	display: flex;
  	position: relative;
  	height: 100%;
  }
  .interaction img{
    max-width: 100%;
  }
  .fade-leave{
    opacity: 1 !important;
  }
  .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0 !important;
  }
</style>
